import { useState } from 'react';
import { Divider, Link } from '@mui/material';
import { FooterStyled } from './Footer.styled';
import { CopyRightModal } from './CopyRightModal';

export const Footer = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  function handleOpenModal() {
    setOpenModal(true);
  }

  function handleCloseModal() {
    setOpenModal(false);
  }

  return (
    <FooterStyled>
      <Divider />
      <Link
        component="button"
        variant="body2"
        onClick={handleOpenModal}
        minHeight="35px"
      >
        CPT® copyright 2019 American Medical Association. All rights reserved.
      </Link>
      <CopyRightModal open={openModal} handleCloseModal={handleCloseModal} />
    </FooterStyled>
  );
};
